import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallBtn',
  props: {
  primary: {
    type: String,
    default: "Add to Chrome ➜",
  },
  secondary: {
    type: String,
    default: "- it's free"
  },
},
  setup(__props) {

const props = __props




function install() {
  // @ts-ignore
  window.gtag("event", "click install button", {
    event_category: "install",
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    onClick: install,
    target: "_blank",
    size: "large",
    color: "accent",
    href: "https://chrome.google.com/webstore/detail/lipsurf/lnnmjmalakahagblkkcnjkoaihlfglon"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(__props.primary), 1)
    ]),
    _: 1
  }))
}
}

})